
import { useEffect } from 'react';
import { initializeStorage } from '@/utils/storageSetup';
import { logger } from '@/utils/logger';

export const useAppInitialization = () => {
  useEffect(() => {
    const initializeApp = async () => {
      try {
        logger.debug('Initializing application...');
        
        // Initialize storage buckets
        await initializeStorage();
        
        logger.debug('Application initialization completed');
      } catch (error) {
        logger.error('Failed to initialize application:', error);
      }
    };

    initializeApp();
  }, []);
};
